<script>
export default {
  props: {
    subsidiaryLedgers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      sl: this.subsidiaryLedgers,
      centers: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "title",
          label: "Title",
        },
        {
          key: "account",
          label: "Account",
        },
        {
          key: "reference",
          label: "Reference",
        },
      ],
      tableBusy: false,
      viewModel: false,
    };
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    selectRow(data) {
      this.$emit("selectRow", data);
    },
  },
  watch: {
    subsidiaryLedgers: {
      handler: function (val) {
        this.sl = val;
        this.totalRows = val.length;
      },
      deep: true,
    },
  },
};
</script>

<template>
  <div id="datatable_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            Show&nbsp;
            <b-form-select
              class="form-select form-select-sm mx-1"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            >
            </b-form-select
            >&nbsp;entries
          </label>
        </div>
      </div>
      <!-- Search -->
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_filter" class="dataTables_filter text-md-end">
          <label class="d-inline-flex align-items-center">
            Search:
            <b-form-input
              v-model="filter"
              type="search"
              placeholder="Search..."
              class="form-control form-control-sm ms-2"
            ></b-form-input>
          </label>
        </div>
      </div>
      <!-- End search -->
    </div>

    <div class="row">
      <div class="col-lg-12 mb-2">
        <div class="d-flex justify-content-between">
          <small class="text-warning mt-2"
            >** Double click row to select subsidiary ledger</small
          >
          <b-button size="sm" variant="info" @click="$bvModal.show('newSLModal')"
            >Create New SL</b-button
          >
        </div>
      </div>
      <!-- table data -->
      <div class="col-lg-12">
        <div class="custom-table-responsive mb-0">
          <b-table
            class="table"
            :items="subsidiaryLedgers"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-desc.sync="sortDesc"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
            show-empty
            bordered
            outlined
            hover
            striped
            select-mode="single"
            selectable
            :busy="$store.state.subsidiaryledger.isSubsidiaryLedgersLoading"
            @row-dblclicked="selectRow"
            selected-variant="success"
          >
            <template #empty="scope">
              <div class="text-center text-info">
                <h5 class="text-secondary">{{ scope.emptyText }}</h5>
              </div>
            </template>
            <template #cell(title)="row">
              <h5 class="mb-0 text-info">{{ row.item.title }}</h5>
              <span class="d-block">{{ row.item.description }}</span>
              <span class="badge bg-success">{{ row.item.type.toUpperCase() }}</span>
            </template>
            <template #cell(account)="row">
              <span class="badge rounded-pill bg-success">{{
                row.item.account ? row.item.account.uacs : "---"
              }}</span>
              -
              <span>{{ row.item.account ? row.item.account.accountName : "---" }}</span>
            </template>
            <template #cell(reference)="row">
              <p class="mb-0">
                <span>Name: </span
                ><strong class="text-yellow">{{
                  row.item.clientDto ? row.item.clientDto.name : "---"
                }}</strong>
              </p>
              <p class="mb-0">
                <span>Address/Position: </span
                ><strong class="text-yellow">{{
                  row.item.clientDto ? row.item.clientDto.addressPosition : "---"
                }}</strong>
              </p>
              <p class="mb-0">
                <span>Reference Type: </span
                ><strong class="text-yellow">{{
                  row.item.clientDto ? row.item.clientDto.type.toUpperCase() : "---"
                }}</strong>
              </p>
            </template>
            <template #table-busy>
              <div class="text-center">
                <h5 class="text-secondary mb-0">
                  <i class="bx bx-hourglass bx-spin me-2"></i> Fetching data...
                </h5>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <!-- table data -->
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
